export default function ChallengeHUD({ challenge }) {
  if (!challenge?.isChallenge) return null;

  const {
    status, violation, challengeName,
    profitTarget, profitTargetPct, currentProfit, profitPercent,
    todayPnl, todayPnlPercent, dailyLossLimit, dailyLossLimitPct,
    currentDrawdown, drawdownPercent, maxDrawdownLimit, maxDrawdownPct,
    tradingDays, minTradingDays, leverage, accountType,
  } = challenge;

  const profitProgress = Math.min(100, Math.max(0, (profitPercent / profitTargetPct) * 100));
  const dailyLossProgress = Math.min(100, Math.max(0, (Math.abs(Math.min(0, todayPnlPercent)) / dailyLossLimitPct) * 100));
  const ddProgress = Math.min(100, Math.max(0, (drawdownPercent / maxDrawdownPct) * 100));

  return (
    <div className={`challenge-hud ${status === 'failed' ? 'challenge-failed' : status === 'passed' ? 'challenge-passed' : ''}`}>
      {/* Status + Name */}
      <div className="challenge-hud-header">
        <span className={`challenge-status-badge challenge-status-${status}`}>
          {status.toUpperCase()}
        </span>
        <span className="challenge-name">{challengeName}</span>
        <span className="challenge-meta">
          {accountType} 1:{leverage}
        </span>
      </div>

      {/* Violation alert */}
      {violation && (
        <div className="challenge-violation">{violation}</div>
      )}

      {/* Progress bars */}
      <div className="challenge-bars">
        {/* Profit Target */}
        <div className="challenge-bar-group">
          <div className="challenge-bar-label">
            <span>Profit</span>
            <span className={currentProfit >= 0 ? 'pnl-positive' : 'pnl-negative'}>
              {currentProfit >= 0 ? '+' : ''}{currentProfit.toFixed(2)} / {profitTarget.toFixed(0)}
              <small> ({profitPercent.toFixed(1)}% / {profitTargetPct}%)</small>
            </span>
          </div>
          <div className="challenge-bar">
            <div className="challenge-bar-fill challenge-bar-profit"
              style={{ width: `${profitProgress}%` }} />
          </div>
        </div>

        {/* Daily Loss */}
        <div className="challenge-bar-group">
          <div className="challenge-bar-label">
            <span>Daily Loss</span>
            <span className={todayPnl < 0 ? 'pnl-negative' : ''}>
              {todayPnl.toFixed(2)} / -{dailyLossLimit.toFixed(0)}
              <small> ({todayPnlPercent.toFixed(1)}% / -{dailyLossLimitPct}%)</small>
            </span>
          </div>
          <div className="challenge-bar">
            <div className={`challenge-bar-fill ${dailyLossProgress > 80 ? 'challenge-bar-danger' : 'challenge-bar-loss'}`}
              style={{ width: `${dailyLossProgress}%` }} />
          </div>
        </div>

        {/* Max Drawdown */}
        <div className="challenge-bar-group">
          <div className="challenge-bar-label">
            <span>Max Drawdown</span>
            <span className={currentDrawdown > 0 ? 'pnl-negative' : ''}>
              -{currentDrawdown.toFixed(2)} / -{maxDrawdownLimit.toFixed(0)}
              <small> ({drawdownPercent.toFixed(1)}% / {maxDrawdownPct}%)</small>
            </span>
          </div>
          <div className="challenge-bar">
            <div className={`challenge-bar-fill ${ddProgress > 80 ? 'challenge-bar-danger' : 'challenge-bar-dd'}`}
              style={{ width: `${ddProgress}%` }} />
          </div>
        </div>
      </div>

      {/* Stats row */}
      <div className="challenge-stats-row">
        <span>Trading Days: {tradingDays}/{minTradingDays}</span>
      </div>
    </div>
  );
}
